/* ============================================================================
   ISHA COLLECTIONS - PRODUCT CARD JS (WITH CLOUDFLARE BYPASS & AUTO-INIT)
============================================================================ */

(function () {
  if (window.__ISHA_CARD_INIT__) return;
  window.__ISHA_CARD_INIT__ = true;

  // CLOUDFLARE BYPASS: Add to Cart Function
  async function ishaAddToCart(variantId, button) {
    const cartDrawer = document.querySelector("cart-drawer");
    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);
    
    let sections = [];
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
       sections = cartDrawer.getSectionsToRender().map((s) => s.id);
    }
    if (sections.length === 0) sections = ["cart-drawer", "cart-icon-bubble"];
    
    formData.append("sections", sections.join(","));
    formData.append("sections_url", window.location.pathname);

    const fetchUrl = window.Shopify.routes.root + 'cart/add.js';
    
    try {
        // The magic headers that bypass Cloudflare Turnstile
        const response = await fetch(fetchUrl, { 
            method: "POST", 
            body: formData, 
            headers: { 
                "X-Requested-With": "XMLHttpRequest", 
                "Accept": "application/javascript" 
            }
        });
        
        const parsedState = await response.json();

        if (parsedState.status === 422 || parsedState.status === 404) {
             const errorMsg = parsedState.description || parsedState.message || "Item could not be added.";
             alert(errorMsg);
             if(button) button.textContent = "Add to cart";
             return;
        }

        // Update Cart Bubble
        const cartBubble = document.getElementById('cart-icon-bubble');
        if (cartBubble && parsedState.sections && parsedState.sections['cart-icon-bubble']) {
             const doc = new DOMParser().parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html');
             const inner = doc.querySelector('#cart-icon-bubble');
             if (inner) cartBubble.innerHTML = inner.innerHTML;
        }

        // Update and Open Cart Drawer
        if (cartDrawer) {
            cartDrawer.classList.remove('is-empty'); 
            const drawerInner = cartDrawer.querySelector('.drawer__inner');
            if (drawerInner) drawerInner.classList.remove('is-empty');

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { 
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'isha-product-card', cartData: parsedState, productVariantId: variantId }); 
            }

            if (typeof cartDrawer.renderContents === "function") {
                cartDrawer.renderContents(parsedState);
            } else if (parsedState.sections && parsedState.sections['cart-drawer']) {
                 const doc = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');
                 const inner = doc.querySelector('#CartDrawer');
                 if (inner && document.querySelector('#CartDrawer')) document.querySelector('#CartDrawer').innerHTML = inner.innerHTML;
            }
            
            if (typeof cartDrawer.open === "function") cartDrawer.open();
            else cartDrawer.classList.add('active', 'animate');
            
            if(button) {
                button.textContent = "Added ✓";
                setTimeout(() => { button.textContent = "Add to cart"; button.disabled = false; }, 2000);
            }
        } else {
            window.location.href = window.Shopify.routes.root + 'cart';
        }
    } catch (err) {
        console.error("Cart Error:", err);
        window.location.href = window.Shopify.routes.root + 'cart';
    }
  }

  // CLOUDFLARE BYPASS: Buy Now Function
  async function ishaBuyNow(variantId) {
    try {
      // Clear cart first so they only buy this one item
      await fetch(window.Shopify.routes.root + "cart/clear.js", { method: "POST", headers: { "X-Requested-With": "XMLHttpRequest" } });
      
      const formData = new FormData();
      formData.append("id", variantId); 
      formData.append("quantity", 1);
      
      const fetchUrl = window.Shopify.routes.root + 'cart/add.js';
      const response = await fetch(fetchUrl, { 
          method: "POST", 
          body: formData,
          headers: { "X-Requested-With": "XMLHttpRequest" }
      });
      
      if (response.ok) {
          window.location.href = "/checkout";
      } else {
          const data = await response.json();
          alert(data.description || "Unable to buy now. Item may be out of stock.");
      }
    } catch (err) { 
        alert("Unable to start checkout. Please try again."); 
    }
  }

  // Initialize individual product cards
  function initIshaCard(card) {
    if (!card || card.__isha_init) return;
    card.__isha_init = true; // Prevents double-attaching events

    const sizeBtns = card.querySelectorAll('.isha-size-btn');
    const mrpEl = card.querySelector('.isha-mrp');
    const salePriceEl = card.querySelector('.isha-sale-price');
    const urgencyBadge = card.querySelector('.isha-urgency');
    const stockCountEl = card.querySelector('.isha-stock-count');
    const addCartBtn = card.querySelector('.isha-add-cart');
    const buyNowBtn = card.querySelector('.isha-buy-now');
    const errorMsg = card.querySelector('.isha-error-msg');

    // Handle Size Selection
    sizeBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        if (this.disabled) return; 

        sizeBtns.forEach(b => b.classList.remove('is-selected'));
        this.classList.add('is-selected');

        const variantId = this.getAttribute('data-variant-id');
        const price = this.getAttribute('data-price');
        const comparePrice = this.getAttribute('data-compare-price');
        const inventory = parseInt(this.getAttribute('data-inventory')) || 0;
        const isAvailable = this.getAttribute('data-available') === 'true';

        card.setAttribute('data-current-variant', variantId);
        if(errorMsg) errorMsg.style.display = 'none';

        if(salePriceEl) salePriceEl.innerHTML = price;
        if (mrpEl) {
            if (comparePrice && comparePrice !== price && comparePrice !== "₹0.00" && comparePrice !== "$0.00") {
              mrpEl.innerHTML = comparePrice;
              mrpEl.style.display = 'inline-block';
            } else {
              mrpEl.style.display = 'none';
            }
        }

        if (urgencyBadge && stockCountEl) {
            if (isAvailable && inventory > 0 && inventory <= 5) {
              stockCountEl.innerHTML = inventory;
              urgencyBadge.style.display = 'inline-flex';
            } else {
              urgencyBadge.style.display = 'none';
            }
        }
      });
    });

    // Handle Add to Cart Click
    if (addCartBtn) {
      addCartBtn.addEventListener('click', function() {
        const variantId = card.getAttribute('data-current-variant');
        
        if (!variantId || variantId === "") {
          if(errorMsg) {
              errorMsg.textContent = "⚠ Please select a size first";
              errorMsg.style.display = 'block';
          }
          return;
        }

        this.textContent = 'Adding...';
        this.disabled = true;
        ishaAddToCart(variantId, this);
      });
    }

    // Handle Buy Now Click
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function() {
        const variantId = card.getAttribute('data-current-variant');
        if (!variantId || variantId === "") {
          if(errorMsg) {
              errorMsg.textContent = "⚠ Please select a size first";
              errorMsg.style.display = 'block';
          }
          return;
        }
        
        const originalText = this.textContent;
        this.textContent = 'Processing...';
        ishaBuyNow(variantId).finally(() => {
            this.textContent = originalText;
        });
      });
    }
  }

  // Find all cards on the page and initialize them
  function initAllCards(root = document) { 
      const cards = root.querySelectorAll(".isha-card");
      cards.forEach(initIshaCard); 
  }

  // Run on page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => { initAllCards(); });
  } else { 
      initAllCards(); 
  }

  // MUTATION OBSERVER: This watches the page for changes (like Collection Page AJAX filtering)
  // If new products appear, it automatically connects the Add to Cart buttons to them!
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => { 
            if (node.nodeType === 1) initAllCards(node); 
        });
    });
  });
  
  observer.observe(document.body, { childList: true, subtree: true });

})();